import { IDataTableColumn, Loading } from "nsitools-react";
import * as React from "react";
import { Link } from "react-router-dom";

import { CharacteristicValuesApi, CharacteristicValuesGridDto, CharacteristicValuesSearch } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { ICustomSelectorProps, SRSHCustomSelector } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface ICharacteristicsTypeSelectorProps
  extends Pick<ICustomSelectorProps<any>, "linkedIds" | "onLinkedIdsChanged"> {
  editMode: boolean;
  loading: boolean;
}

export const CharacteristicsTypeSelector: React.FunctionComponent<ICharacteristicsTypeSelectorProps> = ({
  linkedIds,
  onLinkedIdsChanged,
  editMode,
  loading,
}) => {
  const characteristicValuesApi = useApiService(CharacteristicValuesApi);
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();

  const searchIdsFunction = React.useCallback(
    (sObj: any) =>
      characteristicValuesApi.getIds(
        CharacteristicValuesSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })
      ),
    [characteristicValuesApi, currentLanguage.languageId]
  );
  const searchFunction = React.useCallback(
    (sObj: any) =>
      characteristicValuesApi.baseSearch(
        CharacteristicValuesSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })
      ),
    [characteristicValuesApi, currentLanguage.languageId]
  );

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
        render: (dto: CharacteristicValuesGridDto) => (
          <Link target="_blank" to={`${ERoutes.characteristicValues}/${dto.healthValueId}/detail/view`}>
            {dto.name}
          </Link>
        ),
      },
    ],
    [t]
  );
  return (
    <Loading isLoading={loading}>
      <SRSHCustomSelector
        linkedIds={linkedIds}
        columns={columns}
        onLinkedIdsChanged={onLinkedIdsChanged}
        idField="healthValueId"
        searchFunction={searchFunction}
        searchIdsFunc={searchIdsFunction}
        editMode={editMode}
        sortKeys={{ name: "ASC" }}
      />
    </Loading>
  );
};
